import { SpeechToTextStatus } from '../../constants/speechToText'

import { DeepgramMessageType } from './useSpeechToText.constants'

export function isSpeechToTextStatusIdle(status) {
  return status === SpeechToTextStatus.Idle
}

export function isSpeechToTextStatusConnecting(status) {
  return status === SpeechToTextStatus.Connecting
}

export function isSpeechToTextStatusReady(status) {
  return status === SpeechToTextStatus.Ready
}

export function isSpeechToTextStatusRecording(status) {
  return status === SpeechToTextStatus.Recording
}

export function isSpeechToTextStatusStopping(status) {
  return status === SpeechToTextStatus.Stopping
}

export function isDeepgramMessageTypeResults(type) {
  return type === DeepgramMessageType.Results
}
